<template>
    <b-modal
        ref="editComponentModal"
        cancel-variant="outline-secondary"
        size="lg"
        centered
        :title="title"
        hide-footer
        @hide="$emit('modalHide')"
    >
        <validation-observer
            ref="general"
        >
            <validation-provider
                #default="{ errors }"
                :name="$t('Component(SelectOrMakeProduct):number-of-units')"
                rules="required|greaterThanZero|integer"
            >
                <b-form-group
                    :label="$t('Component(SelectOrMakeProduct):number-of-units')"
                    label-for="numberOfUnits"
                >
                    <b-form-input
                        number
                        autofocus
                        :state="errors.length > 0 ? false:null"
                        type="number"
                        name="numberOfUnits"
                        min="1"
                        v-model="numberOfUnits"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
            </validation-provider>
        </validation-observer>
        <div class="text-right">
            <Button
                @click="save"
            >
                {{ $t('Component(Button):save') }}
            </Button>
            <Button
                class="ml-50"
                @click="close"
            >
                {{ $t('Component(Button):cancel') }}
            </Button>
            <Button
                class="ml-50"
                v-if="options.isDeleteButtonVisible"
                variant="danger"
                @click="deleteComponent"
            >
                {{ $t('Component(Button):remove') }}
            </Button>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BFormGroup, BFormInput } from 'bootstrap-vue'
import {Button} from "@core/components/common";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {required, integer, greaterThanZero} from '@validations'


//  NOT IN USE YET
export default {
    components: {
        BModal, Button, ValidationProvider, ValidationObserver, BFormGroup, BFormInput
    },
    data() {
        return {
            component: {
                title: ''
            },
            numberOfUnits: 1,
            options: {
                isDeleteButtonVisible: false,
                showSupplierOptions: false
            },
            required, integer, greaterThanZero
        };
    },
    methods: {
        show(component, options) {
            this.component = component;
            this.options = options;
            this.numberOfUnits = component.numberOfUnits;
            this.$refs.editComponentModal.show();
        },
        deleteComponent() {
            this.$emit('delete', this.component);
            setTimeout(() => {
                this.close();
            }, 400);
        },
        save() {
            this.$refs.general.validate().then(isValid => {
                if (isValid) {
                    this.$emit('save', this.component, {
                        numberOfUnits: this.numberOfUnits
                    });
                    this.close();
                }
            });
        },
        close() {
            this.$refs.editComponentModal.hide();
        },
        suppliersChange(suppliers) {

        }
    },
    computed: {
        title() {
            return this.$t('Page(ReceivedRequest):Component(EditComponent):title', {component: this.component.title});
        }
    }
}
</script>
